// extracted by mini-css-extract-plugin
export default {"companyContainer":"aM-z","companyImage":"bM-z","container":"cM-z","heading":"dM-z","darkText":"eM-z","smallHeading":"fM-z","darkBackground":"gM-z","whiteBackground":"hM-z"};